export default {
  shopNow: 'Acheter maintenant',
  preSale: 'Acheter',
  header: {
    title: 'Votre portefeuille matériel crypto sécurisé',
    subtitle: 'Stockez et gérez vos crypto-actifs en toute sécurité et simplicité',
  },
  introduce: {
    title: 'Vous méritez un meilleur portefeuille matériel',
    subtitle: 'Sécurisé · Fiable · Simple',
    desc_1: 'Coque solide protégeant le portefeuille des dommages',
    desc_2: 'Puce de grade militaire garantissant la sécurité',
    desc_3: 'Appareils identifiés pendant l’utilisation',
    desc_4: 'Clés générées hors ligne et stockées localement',
    desc_5: 'Vous signez ce que vous voyez',
    desc_6: 'Code PIN pris en charge',
  },
  function: {
    title: 'Un portefeuille matériel crypto tout-en-un',
    subtitle: 'Un seul portefeuille pour tous vos besoins crypto',
    func_title_1: 'Sécuriser & stocker',
    func_desc_1:
      'Générez vos clés et stockez-les dans votre KeyPal avec les puces les plus sûres au monde. Plus de 1000 chaînes prises en charge. Vous seul y avez accès.',
    func_title_2: 'Acheter & faire croître',
    func_desc_2:
      'Achetez du Bitcoin, de l’Ether et d’autres cryptomonnaies de manière simple, sûre et intelligente. Faites-les croître sans quitter le portefeuille.',
    func_title_3: 'Échange & cross-chain',
    func_desc_3:
      'Échangez vos cryptomonnaies en quelques secondes entre les chaînes prises en charge ; migrez facilement vos actifs d’une chaîne à une autre.',
    func_title_4: 'Débloquer les possibilités de la crypto',
    func_desc_4:
      'Accédez en toute sécurité à toutes les applications décentralisées — DeFi, DApp, GameFi et NFT.',
  },
  software: {
    title: 'KeyPal & TokenPocket',
    connect: 'Méthodes de connexion',
    crossPlatform: 'Compatible multi-plateforme',
    multiChains: 'Prise en charge multi-chaînes',
    supportDesc:
      '(Prend en charge toutes les chaînes compatibles EVM, comme BNB Smart Chain, Polygon, ETC, Arbitrum)',
    more: 'Plus',
  },
  specification: {
    title: 'Spécifications',
    card_1: 'Cœur',
    option_label_1_1: 'Puces',
    option_desc_1_1: 'MCU + SE',
    option_label_1_2: 'Certifications et normes',
    option_desc_1_2: 'DOE, CEC, BEC, CE, FCC & RoHS',

    card_2: 'Batterie et connecteur',
    option_label_2_1: 'Batterie',
    option_desc_2_1: '300 mAh',
    option_label_2_2: 'Connecteur',
    option_desc_2_2: 'USB Type-C',

    card_3: 'Dimensions et poids',
    option_label_3_1: 'Dimensions',
    option_desc_3_1: '91 x 55 x 9.0(mm)',
    option_label_3_2: 'Poids',
    option_desc_3_2: '63(g)',

    card_4: 'Affichage',
    option_label_4_1: 'Écran',
    option_desc_4_1: '2 pouces',
    option_label_4_2: 'Affichage',
    option_desc_4_2: 'LCD, couleur',
    option_label_4_3: 'Résolution',
    option_desc_4_3: '320 x 480',

    card_5: 'Compatibilité',
    option_desc_5_1: 'iOS, Android, macOS, Windows, Linux',

    card_6: 'Méthodes de connexion',
    option_desc_6_1: 'Bluetooth & USB Type-C',

    card_7: 'Matériaux',
    option_desc_7_1: 'Alliage d’aluminium',

    card_8: 'Couleurs',
    option_desc_8_1: 'Noir, Argent, Or',

    btnTitle: 'Prêt à utiliser le portefeuille KeyPal',
    btnSubTitle: 'Votre portefeuille matériel crypto sécurisé',
  },
}
